var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"checkmark"}),(_vm.label)?_c('span',{staticClass:"m-l-10"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }